
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5af7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5af7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lA1wN", function(module, exports) {

$parcel$export(module.exports, "initHeaderActiveNav", function () { return $fb5e25347d6b7784$export$9a4306cb330df17c; });
$parcel$export(module.exports, "initHeaderCTA", function () { return $fb5e25347d6b7784$export$439db37d80004144; });
// assets/js/layout/header.js
function $fb5e25347d6b7784$export$9a4306cb330df17c() {
    const page = document.body.dataset.page;
    if (!page) return;
    document.querySelectorAll('.top-bar__nav-pill a, .top-bar__nav-panel a').forEach((link)=>{
        if (link.dataset.nav === page) link.classList.add('is-active');
    });
}
function $fb5e25347d6b7784$export$439db37d80004144() {
    const cta = document.querySelector('[data-header-cta]');
    if (!cta) return;
    const page = document.body.dataset.page;
    switch(page){
        case 'inicio':
        case 'cuestionarios':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'planes':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'info':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'app':
            cta.innerHTML = `
				<!-- \u{1F510} AUTH BAR (renderizada por AuthHeaderController + AuthHeaderView) -->
				<div class="auth-bar" data-auth-header></div>
			`;
            break;
        default:
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html">[...to be configured]</a>
			`;
    }
}

});


var $lA1wN = parcelRequire("lA1wN");
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $lA1wN.initHeaderActiveNav)();
    (0, $lA1wN.initHeaderCTA)();
});


//# sourceMappingURL=plans.d1d05aba.js.map
